// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		"busDate": "",
		"checkAcceptId": "",
		"checkAcceptState": 0,
		"checkAcceptTime": "",
		"clinicId": "",
		"creater":'',
		"costAmt": 0,
		"createId": "",
		"createTime": "",
		"docNum": "",
		"id": "",
		"invoDate": "",
		"nullify": "",
		"nullifyId": "",
		"nullifyTime": "",
		"passingOrdersId": "",
		"passingOrdersTime": "",
		"payAmt": 0,
		"payState": "",
		"phayId": 4,
		"printCnt": "",
		"purcInvoCodg": "",
		"putinTypeId": 2,
		"remarks": "",
		"reviewId": "",
		"reviewTime": "",
		"saleAmt": "",
		"state": 0,
		"supplyCandidateId": "",
		"supplierName":'',
		"supplyCode": "",
		"terminalId": "",
		"tcmDocDetails": [
			{
				"clinicId": "",
				"docId": "",
				"drugId": "",
				"expyDate": "",
				"id": 0,
				"invId": "",
				"manuDate": "",
				"manuLotnum": "",
				"markUpPric": "",
				"markUpRate": "",
				"maxPurcPric": "",
				"maxSalePric": "",
				"minPurcPric": "",
				"minSalePric": "",
				"nullifyCnt": "",
				"nullifyDocId": "",
				"nullifyId": "",
				"nullifyState": "",
				"nullifyTime": "",
				"nullifyWaitCnt": "",
				"prodentpName": "",
				"prodentpNameId": "",
				"purcAmt": "",
				"purcCnt": "",
				"purcPric": "",
				"purcType": "",
				"saleAmt": "",
				"salePric": "",
				"unt":''
			}
		]
	}
]

